import React from 'react';
import Button from '@mui/material/Button';

const FillButton = ({
    backgroundColor,
    textColor,
    text,
    cornerRadius,
    fontSize,
    onClick,
}) => {

    const buttonStyle = {
        textTransform: 'none',
        width: "200px",
        height: "45px",
        backgroundColor: backgroundColor,
        borderRadius: cornerRadius ? cornerRadius : '16px',
        color: textColor,
        boxShadow: 'none',
        fontSize: fontSize ? fontSize : "16px",
        '&:hover': {
            backgroundColor: backgroundColor,
        },
    };

    return (
        <Button
            style={buttonStyle}
            onClick={onClick}
            variant="contained"
        >
            {text}
        </Button>
    );
};

export default FillButton;
